import { Row, Col, Typography } from 'antd'
import { t } from 'i18next'

import './OrderDetailInfo.scss'

import { useFetchOrderDetailsMutation } from 'store/reducers/salaryCards/orderDetails.api'

const { Text } = Typography

const RowItem = ({
  label,
  value,
  red = false,
}: {
  label: string
  value: string | number | React.ReactNode
  red?: boolean
}) => (
  <div className="rowBorderBottom flexRow">
    <Text className="custom-text-color">{label}: </Text>
    <Text style={red ? { color: 'red' } : undefined}>{value}</Text>
  </div>
)

const OrderDetailModalHeader = () => {
  const [_, { data: detailInformationList = {} }] =
    useFetchOrderDetailsMutation({ fixedCacheKey: 'fetchOrderDetails' })

  const {
    cardCurrency,
    cardType,
    orderType,
    orderDeliveryType,
    branchTransferredName,
    orderBranchName,
    totalCount,
    rejectedCount,
    note,
    trustedPerson = {},
  } = detailInformationList || {}

  const { fullName, pin, phone, expiryDate } = trustedPerson

  return (
    <Row justify="space-evenly" gutter={[96, 96]} style={{ marginBottom: '20px' }}>
      <Col md={8}>
        <RowItem label={t('orders.salaryCardOrder.inputLabels.cardCurrency')} value={cardCurrency} />
        <RowItem label={t('orders.salaryCardOrder.inputLabels.cardType')} value={cardType} />
        <RowItem
          label={t('orders.salaryCardOrder.inputLabels.orderTypes')}
          value={t(`orders.salaryCardOrder.constants.${orderType}`)}
        />
        <RowItem
          label={t('orders.salaryCardOrder.tableTitles.receivingTransfer')}
          value={t(`orders.salaryCardOrder.constants.${orderDeliveryType}`)}
        />
      </Col>

      <Col md={8}>
        <RowItem
          label={t('orders.salaryCardOrder.inputLabels.orderBranch')}
          value={orderBranchName}
        />
        <RowItem
          label={t('orders.salaryCardOrder.inputLabels.BranchTransferred')}
          value={branchTransferredName}
        />
        <RowItem
          label={t('orders.salaryCardOrder.tableTitles.totalNumberOfRejections')}
          value={
            <>
              {totalCount}/<span style={{ color: 'red' }}>{rejectedCount}</span>
            </>
          }
        />
        <RowItem label={t('orders.salaryCardOrder.inputLabels.note')} value={note} />
      </Col>

      <Col md={8}>
        <RowItem label={t('orders.salaryCardOrder.inputLabels.fullNameEtibar')} value={fullName} />
        <RowItem label={t('orders.salaryCardOrder.inputLabels.pin')} value={pin} />
        <RowItem label={t('orders.salaryCardOrder.tableTitles.phoneNumber')} value={phone} />
        <RowItem label={t('orders.salaryCardOrder.tableTitles.expiryDate')} value={expiryDate} />
      </Col>
    </Row>
  )
}

export default OrderDetailModalHeader
